import { Preferences } from '@capacitor/preferences'

import * as types from '../mutation-types'

async function getPreference (key) {
  const result = await Preferences.get({ key });
  return result.value ? JSON.parse(result.value) : null;
}

async function setPreference (key, value) {
  return await Preferences.set({ key, value: JSON.stringify(value) });
}

async function removePreference (key) {
  return await Preferences.remove({ key: key })
}

const { locale, locales } = window.config

// state
export const state = {
  locale: locale,
  locales: locales
}

// Initialize the actual locale after module loads
getLocale(locales, locale).then(resolvedLocale => {
  state.locale = resolvedLocale
})

// getters
export const getters = {
  locale: state => state.locale,
  locales: state => state.locales
}

// mutations
export const mutations = {
  [types.SET_LOCALE] (state, { locale }) {
    state.locale = locale
  }
}

// actions
export const actions = {
  async setLocale ({ commit }, { locale }) {
    commit(types.SET_LOCALE, { locale })
    await setPreference('locale', locale)
    
    // Load i18n messages for the new locale
    const { loadMessages } = await import('~/plugins/i18n.js')
    await loadMessages(locale)
  }
}

/**
 * @param  {String[]} locales
 * @param  {String} fallback
 * @return {String}
 */
async function getLocale (locales, fallback) {
  const locale = await getPreference('locale')
  if (locale && Object.prototype.hasOwnProperty.call(locales, locale)) {
    return locale
  } else if (locale) {
    await removePreference('locale')
  }

  return fallback
}
